import { CompanyEventStatusEnumType } from '__generated__/graphql';

interface ReadableType {
  label: string;
  color: 'gray' | 'blue' | 'green' | 'yellow' | 'red';
  customIcon?: string;
}

const companyEventStatusToReadable = (status: CompanyEventStatusEnumType): ReadableType => {
  switch (status) {
    case CompanyEventStatusEnumType.Pending:
      return {
        label: 'Pending',
        color: 'yellow',
        customIcon: '⚠ ',
      };
    case CompanyEventStatusEnumType.Authorized:
      return {
        label: 'Authorized',
        color: 'green',
        customIcon: '✓ ',
      };
    case CompanyEventStatusEnumType.Rejected:
      return {
        label: 'Rejected',
        color: 'red',
        customIcon: '✕ ',
      };
    case CompanyEventStatusEnumType.NotApplicable:
      return {
        label: 'Not Applicable',
        color: 'gray',
      };
    default:
      return {
        label: 'Unknown',
        color: 'gray',
      };
  }
};

export default companyEventStatusToReadable;
